<template>
    <div v-observe-visibility="visibilityChanged">

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout row wrap>

            <v-flex xs12 sm12 pr-4 pt-4 pl-4>

                <v-btn class="secondary white--text" @click.native="openSupplierOfferPositionDialog()">
                    New Supplier Offer Position
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Supplier Offer Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openSupplierOfferPositionDialog(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{props.item.unit.code }}</td>
                                <td class="text-xs-right">{{props.item.unit_price}}
                                    {{props.item.suppliers_offer.currency.name}}
                                </td>

                                <td class="text-xs-right">

                                    <v-icon color="red"
                                            class="ma-1"
                                            @click="deletePositionDialog(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-end mr-5>
            <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>
                <!--             <v-btn :loading="getCreatingPurchaseOrderMessage" class="secondary white&#45;&#45;text"
                                    @click.native="createCustomerOrderConfirmation()">
                                 Create Order Confirmation
                             </v-btn>-->
            </v-flex>
        </v-layout>
        <!--Add Position Dialog-->
        <addSupplierOfferPositionDialog></addSupplierOfferPositionDialog>

    </div>
</template>

<script>
    import {
        SupplierOffers,
        SupplierOfferPositions
    } from '../../../store/namespace-helper'

    import addSupplierOfferPositionDialog from './AddSupplierOfferPositionDialog.vue'

    import _ from 'lodash'

    export default {
      name: 'supplier-offer-positions',
      components: {addSupplierOfferPositionDialog},
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Unit Price', value: 'unit_sales_price', align: 'right'},
                    {text: 'Action', value: 'action', sortable: false}
          ],
          pagination: {},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          creatingOrderConfirmation: false,
          positionData: null,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab order positions visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.selectedItem.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          if (this.selectedItem.id !== 0) {
            this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionsBySupplierOffer, query)
          }
        },
        openSupplierOfferPositionDialog (val) {
          var item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            console.log('selected supplier offer position: ' + JSON.stringify(item))
            this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, item)
          }
          this.$store.dispatch(SupplierOfferPositions.actions.openCloseDialog)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        deletePositionDialog (item) {
          this.positionData = _.cloneDeep(item)
          this.deleteDialog = true
        },
        deletePosition () {
          if (!this.$refs.form.validate()) {
            return
          }
          this.deleteDialog = false
          this.deleteChecked = false
          this.$store.dispatch(SupplierOfferPositions.actions.deleteSupplierOfferPosition, this.positionData).then(response => {
            if (response !== null) {
              this.loadItems()
            }
          })
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.$refs.form.reset()
        }

      },
      computed: {
        getItems () {
          this.total = this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositionsBySupplierOffer].length
          return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositionsBySupplierOffer]
        },
        selectedItem () {
          return this.$store.getters[SupplierOffers.getters.getSelectedSupplierOffer]
        },
        loading () {
          return this.$store.getters[SupplierOfferPositions.getters.getLoadingSupplierOfferPosition]
        },
            /*        getCreatingPurchaseOrderMessage () {
                      return this.$store.getters[PurchaseOrder.getters.getCreatingPurchaseOrderMessage]
                    }, */
        positionDialogState () {
          return this.$store.getters[SupplierOfferPositions.getters.getOpenDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        positionDialogState: {
          handler (val) {
            if (!val) {
              this.loadItems()
            }
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>


// WEBPACK FOOTER //
// src/components/SupplierOffers/SupplierOfferPositions/SupplierOfferPositions.vue